import React from 'react'

const Manual_filtrar_usuarios_regular = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          ¿Cómo filtrar usuarios de manera regular?
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Aprende a filtrar usuarios de forma sencilla dentro del Dashboard de Clau.io.
        </p>
        <iframe
          src="https://scribehow.com/embed/Como_filtrar_usuarios_de_manera_regular__DBw3g-0fRZGijfug7QmZag?as=scrollable"
          className="scribe-iframe-general-90"
          width="100%"
          height="3600"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_filtrar_usuarios_regular
